export { default } from './RegisterPractice';